import React, { Component } from 'react'
import { Container, Row, Col, Form, Button, Table, Card} from "react-bootstrap";

import C from '../lib/Config';
import '../App.css';

const isEmail = (email) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);

export default class ChemoTemplateForPatient extends Component {
    constructor(props) {
        super(props)
        this.state = {
            firstName: '',
            lastName: '',
            height: '',
            weight: '',
            bmi: '',
            bsa: '',
            protocolTitle: '',
            schedule: '',
            antiemeticRisk: '',
            antiallergicMedications: '',
            premedications: '',
            chemotherapyDoseAndMethodOfAdministration: '',
            numberOfDaysOfChemotherapyInEachCycle: '',
            postChemotherapyMedications: '',
            fnRisk: '',
            antithromboticProphylaxis: '',
            specialInstructionToPatients: '',
            instructions: '',
            gcsfMedicines: '',
            boneModificationAgents: '',
            chemoTemplateEmailId : '',
            userName: '',
            chemoSupplements: '',
            chemoPremedications: '', 
            instituteArr: [],
            chemoDt: '',
             treatmentPlan:'',
             chemoGiven: false

        };
        this.tempInstructions = '';
        this.handleChange = this.handleChange.bind(this);
        this.contentEditable = React.createRef();
        this.contentEditableRef = React.createRef();
    }
    
    componentDidMount () {
        this.setChemoSittingId();
        this.getChemoTemplateForNurse();
        this.getUserDetails();
        this.getAllInstitutes();
        const patientId = localStorage.getItem('PatientpatientId');
        
        if (patientId) {
            this.getPatientCaseDetail(patientId);
            this.getChemoSittingDetails(patientId);
            this.fetchTreatmentPlan(patientId);
        } else {
            console.error("Patient ID not found in localStorage");
        }
        //const patientId = localStorage.getItem('PatientpatientId');
        if (patientId) {
            this.getPatientCaseDetail(patientId);
            this.getChemoSittingDetails(patientId);
            this.fetchTreatmentPlan(patientId); 
        } else {
            console.error("Patient ID not found in localStorage");
        }

        const firstName = localStorage.getItem('PatientfirstName');
        const lastName = localStorage.getItem('PatientlastName');
        this.setState({
            firstName: firstName,
            lastName: lastName
          });
    }
// fetchTreatmentPlan(patientId) {
//     fetch(`${C.getUrl()}/userCase/getTreatmentDataForNewChemo?patientId=${patientId}`)
//         .then(res => res.json())
//         .then(res => {
//             if (res.statusCode === 200 && res.message) {
//                 try {
//                     const treatmentData = JSON.parse(res.message);
//                     if (treatmentData && treatmentData.length > 0) {
//                         this.setState({ 
//                             treatmentPlan: treatmentData[0].treatmentPlan || 'No treatment plan available'
//                         });
//                     }
//                 } catch (e) {
//                     console.error("Error parsing treatment data:", e);
//                     this.setState({ treatmentPlan: 'Error loading treatment plan' });
//                 }
//             }
//         })
//         .catch(err => {
//             console.error("Error fetching treatment plan:", err);
//             this.setState({ treatmentPlan: 'Error loading treatment plan' });
//         });
// }

    fetchTreatmentPlan(patientId) {
        fetch(`${C.getUrl()}/userCase/getTreatmentDataForNewChemo?patientId=${patientId}`)
            .then(res => res.json())
            .then(res => {
                if (res.statusCode === 200 && res.message) {
                    try {
                        const treatmentData = JSON.parse(res.message);
                        if (treatmentData && treatmentData.length > 0) {
                            const schedules = treatmentData[0].chemoSchedules || [];
                            const today = new Date();
                            today.setHours(0, 0, 0, 0);
                            let currentSchedule = null;
                            schedules.forEach(schedule => {
                                const scheduleDate = new Date(schedule.chemoDt);
                                scheduleDate.setHours(0, 0, 0, 0);
                                if (scheduleDate <= today) {
                                    if (!currentSchedule || scheduleDate > new Date(currentSchedule.chemoDt)) {
                                        currentSchedule = schedule;
                                    }
                                }
                            });
                            this.setState({
                                treatmentPlan: treatmentData[0].treatmentPlan || 'No treatment plan available',
                                currentCycleNumber: currentSchedule ? currentSchedule.chemoCycleNumber : 'N/A',
                                currentTreatmentDay: currentSchedule ? currentSchedule.treatmentDayNumber : 'N/A'
                            });
                        }
                    } catch (e) {
                        console.error("Error parsing treatment data:", e);
                        this.setState({ treatmentPlan: 'Error loading treatment plan', currentCycleNumber: 'N/A', currentTreatmentDay: 'N/A' });
                    }
                }
            })
            .catch(err => {
                console.error("Error fetching treatment plan:", err);
                this.setState({ treatmentPlan: 'Error loading treatment plan', currentCycleNumber: 'N/A', currentTreatmentDay: 'N/A' });
            });
    }

    getChemoSittingDetails(patientId) {
        fetch(C.getUrl() + '/userCase/getChemoSittingDetails?patientId=' + patientId)
            .then(res => res.json())
            .then(res => {
                const resObj = JSON.parse(res.message);
                if (resObj.patientChemoSittingDTO) {
                    // Get treatment given data
                    const treatmentGiven = resObj.patientChemoSittingDTO.treatmentGiven || 'No treatment details available';
                    
                    let chemoDt = '';
                    if (resObj.patientChemoSittingDTO.chemoDt) {
                        // Convert the date string to a more readable format
                        const date = new Date(resObj.patientChemoSittingDTO.chemoDt);
                        chemoDt = date.toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric'
                        }).replace(/\//g, '/');
                    }
                    
                    this.setState({
                        chemoDt,
                        treatmentGiven,
                        chemotherapyDoseAndMethodOfAdministration: treatmentGiven,
                        chemoGiven: resObj.patientChemoSittingDTO.chemoGiven === 1
                    });
                }
            })
            .catch(err => {
                console.log("Error : " + err);
            });
    }

    getPatientCaseDetail(patientId) {
        // Validate patientId before making API call
        if (!patientId || patientId === 'undefined' || patientId === undefined) {
            console.error("Patient ID is undefined or invalid");
            return;
        }
        
        fetch(C.getUrl() + '/userCase/getPatientSummaryDetails?patientId=' + patientId)
            .then(res => res.json())
            .then(res => {
                const resObj = JSON.parse(res.message);
                const instituteName = resObj.patientDetailsDto?.instituteDto?.instituteName ?? '';
                const height = resObj.patientDetailsDto?.height
                    ? `${resObj.patientDetailsDto.height} ${resObj.patientDetailsDto.heightUnitDto?.unitName ?? ''}`
                    : "N/A";
                const weight = resObj.patientDetailsDto?.weight
                    ? `${resObj.patientDetailsDto.weight} ${resObj.patientDetailsDto.weightUnitDto?.unitName ?? ''}`
                    : "N/A";
                this.setState({ instituteName, height, weight }, this.calculateBMI);
 
            })
            .catch(err => {
                console.log("Error: " + err);
                this.setState({ instituteName: 'Error fetching institute name' });
            });
    }
    setChemoSittingId() {
        let chemoSittingId = 1; // Default value or handle it as needed
        if (this.props.location && this.props.location.search) {
            chemoSittingId = this.props.location.search.slice(3);
        }
        this.setState({ chemoSittingId }); // Store it in state
    }

    // The template API returns `null` (not '') for any column that was never filled in.
    // The old `field.length === 0` checks threw a TypeError on those nulls, which rejected
    // the whole .then() chain — so every field parsed AFTER the first null one was silently
    // dropped. chemoSupplements/chemoPremedications are parsed last, so they were always the
    // first casualty. Treat null/undefined/'' uniformly as 'Nil' instead.
    orNil(value) {
        return (value === null || value === undefined || String(value).length === 0) ? 'Nil' : value;
    }

    getChemoTemplateForNurse() {
        var chemoSittingId = 1;
        if (this.props.location && this.props.location.search) {
            chemoSittingId = this.props.location.search.slice(3);
        }
        return fetch(C.getUrl() + '/userCase/getChemoTemplateForNurse/' + chemoSittingId)
        .then(res => res.json())
        .then(res => {
            let resObj = res;
            if (resObj.statusCode == 200 && resObj.message !== 'No record found.') {
                let tempData = JSON.parse(resObj.message);

                this.setState({ protocolTitle: tempData.protocolName });
                this.setState({ schedule: tempData.schedule });
                this.setState({ antiemeticRisk: this.orNil(tempData.antiemeticRisk) });
                this.setState({ antiallergicMedications: this.orNil(tempData.antiallergicMedications) });
                this.setState({ premedications: this.orNil(tempData.premedications) });
                this.setState({ chemotherapyDoseAndMethodOfAdministration: this.orNil(tempData.chemotherapyDoseAndMethodOfAdministration) });
                this.setState({ numberOfDaysOfChemotherapyInEachCycle: this.orNil(tempData.numberOfDaysOfChemotherapyInEachCycle) });
                this.setState({ postChemotherapyMedications: this.orNil(tempData.postChemotherapyMedications) });
                this.setState({ fnRisk: this.orNil(tempData.fnRisk) });
                this.setState({ antithromboticProphylaxis: this.orNil(tempData.antithromboticProphylaxis) });
                this.setState({ specialInstructionToPatients: tempData.specialInstructionToPatients });
                this.setState({ instructions: tempData.instructions });
                this.setState({ gcsfMedicines: this.orNil(tempData.gcsfMedicines) });
                this.setState({ boneModificationAgents: this.orNil(tempData.boneModificationAgents) });
                this.setState({ chemoSupplements: this.orNil(tempData.chemoSupplements) });
                this.setState({ chemoPremedications: this.orNil(tempData.chemoPremedications) });
            }
        })
        .catch(err => {
            // Log the error object (not a string concat) so the stack survives.
            console.error('[ChemoTemplateForPatient] getChemoTemplateForNurse FAILED — remaining fields were not applied', err);
        });
    }
    getUserDetails() {
        const userdetail = {
            firstName: localStorage.getItem("firstName") ? localStorage.getItem("firstName") : "",
            lastName: localStorage.getItem("lastName") ? localStorage.getItem("lastName") : "",
        };

        const fullName = `${userdetail.firstName} ${userdetail.lastName}`;
        this.setState({ userName: fullName});
    }
    printForm(){
        window.print();
    }

    sendChemoTemplateMail() {
        var emailId = this.state.chemoTemplateEmailId;
        if(emailId === ''){
            alert("Please give Email Id first!!!");
        }else if(emailId.indexOf(',') != -1){
            var array = emailId.split(',')
            for(var i = 0; i < array.length; i++) {
                if(!isEmail(array[i])){
                    alert("Invalid Email Id : "+array[i]);
                }
            }
        }else if (!isEmail(emailId)) {
            alert("Invalid Email Id : "+emailId);
        }else{
            let data = {
                "ChemoTeplateData" : {
                    "1" : {"Protocol title" : this.state.protocolTitle},
                    "2" : {"Antiemetic risk" : this.state.antiemeticRisk},
                    "3" : {"Antiallergic medications" : this.state.antiallergicMedications},
                    "4" : {"GCSF medicines" : this.state.gcsfMedicines},
                    "5" : {"Bone modification agents" : this.state.boneModificationAgents},
                    "6" : {"Premedications" : this.state.premedications},
                    "7" : {"Chemotherapy dose and method of administration" : this.state.chemotherapyDoseAndMethodOfAdministration},
                    "8" : {"Number of days of chemotherapy in each cycle" : this.state.numberOfDaysOfChemotherapyInEachCycle},
                    "9" : {"Post chemotherapy medications" : this.state.postChemotherapyMedications},
                    "10" : {"FN risk" : this.state.fnRisk},
                    "11" : {"Antithrombotic prophylaxis" : this.state.antithromboticProphylaxis},
                    "12" : {"Instructions" : this.state.instructions},
                    "13" : {"Special instruction to Patient" : this.state.specialInstructionToPatients}
                },
                "EmailId" : this.state.chemoTemplateEmailId
            }
            return fetch(C.getUrl() + '/email/sendChemoTemplateMail', {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(res => res.json())
            .then(res => {
                let obj = res;
                let error = obj.subErrors;
                if (error !== null && error !== "") {
                    alert(error);
                } else {
                    alert(obj.message);
                }
            })
            .catch(err => {
                console.log("Error : " + err);
            });
        }
    }

    handleChange(event) {
        if (event.target.name == 'chemoTemplateEmailId') {
            this.setState({ chemoTemplateEmailId: event.target.value });
        }
    }
    getAllInstitutes = async () => {
        // Retrieve userId from local storage
        const userId = localStorage.getItem("userId");
        if (!userId) {
            console.error("User ID is not set in local storage.");
            return;
        }
    
        try {
            // Use C.getUrl() to construct the endpoint URL
            const response = await fetch(C.getUrl() + "/institute/getAllInstituteByUserId/" + userId);
            const resObj = await response.json();
    
            const arr = resObj.map((item) => ({
                id: item.instituteId,
                name: item.instituteName,
            }));
    
            this.setState({ instituteArr: arr });
        } catch (err) {
            console.error("Error: ", err);
        }
    };

 // New function to update chemo instructions
 sendPatientUpdatedInstructions() {
    if (!this.state.chemoSittingId) {
        alert('Chemotherapy Sitting ID is required.');
        return;
    }

    const data = {
        patientInstructions: this.state.specialInstructionToPatients, // Adjust this as necessary
    };

    return fetch(C.getUrl() + `/userCase/updateChemoInstructions/${this.state.chemoSittingId}`, {
        method: 'PUT',
        mode: 'cors',
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
        }
    })
    
    .then(res => res.json())
    .then(res => {
        if (res.subErrors) {
            alert(`Error: ${res.subErrors}`);
        } else if (res.error) {
            alert(`Error: ${res.error}`);
        } else {
            alert('Special instructions updated successfully!');
            this.setState({ specialInstructionsUpdated: true });
            setTimeout(() => {
                this.setState({ specialInstructionsUpdated: false });
            }, 3000);
        }
    })
    .catch(err => {
        console.error("Request error:", err);
        this.setState({ errorAlertshow: true });
        setTimeout(() => {
            this.setState({ errorAlertshow: false });
        }, 3000);
    });
}

handleChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
}
handlePrint = () => {
    this.setState({ isPrinting: true }, () => {
        window.print();
        setTimeout(() => {
            this.setState({ isPrinting: false });
        }, 500);
    });
}

handleContentChange = (e) => {
    this.setState({ specialInstructionToPatients: e.currentTarget.textContent });
}

handleChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value }, () => {
        if (name === "height" || name === "weight") {
            this.calculateBMI();
        }
    });
}
calculateBMI = () => {
    const { height, weight } = this.state;
    if (height && weight) {
        // Parse the numeric values from height and weight strings
        const heightValue = parseFloat(height); // Assuming height is in cm
        const weightValue = parseFloat(weight); // Assuming weight is in kg

        if (heightValue > 0 && weightValue > 0) {
            const heightInMeters = heightValue / 100;
            const bmi = (weightValue / (heightInMeters ** 2)).toFixed(1);
            const bsa = Math.sqrt((heightValue * weightValue) / 3600).toFixed(2);
            this.setState({ bmi, bsa });
        } else {
            this.setState({ bmi: 'N/A', bsa: 'N/A' });
        }
    }
};

handleContentChange = (e) => {
    this.tempInstructions = e.target.innerText; // Update temporary variable
};

// Update the state only when editing is complete
handleContentBlur = () => {
    this.setState({ specialInstructionToPatients: this.tempInstructions });
};

    render() {
        const { instituteArr, height, weight, bmi, bsa } = this.state;
        return (
            <div className="d-flex" id="wrapper">
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Container fluid>
                            <div className="app-content">
                                <section className="section" id="accordion">
                                    <div className="form formBackground">
                                        <div className="lightSeperator">
                                        <Card className="custom-card mb-4">
                                            <Card.Body>
                                            <Row>
                                                    <Col lg="12" className="text-center">

                                                         <h2 className="section-title text-center">
                                                         <b>{this.state.instituteName}</b>
                                                        </h2>
                                                    </Col>
                                                </Row>
                                                <hr />
                                                <Row className="d-flex justify-content-between align-items-center">
                                                    <Col lg="12">
                                                    <h1 className="section-title"><b>Dr. {this.state.userName}</b></h1><br></br>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xs={12} style={{ textAlign: 'left' }}>
                                                        <div style={{ position: 'relative', marginBottom: '10px' }}>
                                                            <div style={{ display: 'inline-block' }}>
                                                                <span style={{ fontWeight: 'bold', display: 'inline-block', width: '130px' }}>Patient Name:</span>
                                                                <span>{this.state.firstName} {this.state.lastName}</span>
                                                            </div>
                                                            <div style={{
                                                                position: 'absolute',
                                                                right: '0',
                                                                top: '0',
                                                                display: 'inline-block'
                                                            }}>
                                                                <span style={{ fontWeight: 'bold', marginRight: '10px' }}>Date:</span>
                                                                <span>{this.state.chemoDt || 'N/A'}</span>
                                                            </div>
                                                        </div>
                                                        <div style={{ marginBottom: '10px' }}>
                                                            <span style={{ fontWeight: 'bold', display: 'inline-block', width: '130px' }}>Cycle Number:</span>
                                                            <span>{this.state.currentCycleNumber || 'N/A'}</span>
                                                        </div>
                                                        <div style={{ marginBottom: '10px' }}>
                                                            <span style={{ fontWeight: 'bold', display: 'inline-block', width: '130px' }}>Treatment Day:</span>
                                                            <span>{this.state.currentTreatmentDay || 'N/A'}</span>
                                                        </div>
                                                        <div style={{ marginBottom: '10px' }}>
                                                            <span style={{ fontWeight: 'bold', display: 'inline-block', width: '130px' }}>Height (cm):</span>
                                                            <span>{height}</span>
                                                        </div>
                                                        <div style={{ marginBottom: '10px' }}>
                                                            <span style={{ fontWeight: 'bold', display: 'inline-block', width: '130px' }}>Weight (kg):</span>
                                                            <span>{weight}</span>
                                                        </div>
                                                        <div style={{ marginBottom: '10px' }}>
                                                            <span style={{ fontWeight: 'bold', display: 'inline-block', width: '130px' }}>BMI:</span>
                                                            <span>{bmi}</span>
                                                        </div>
                                                        <div style={{ marginBottom: '10px' }}>
                                                            <span style={{ fontWeight: 'bold', display: 'inline-block', width: '130px' }}>BSA (m²):</span>
                                                            <span>{bsa}</span>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>   <Row>
                                                <Col lg="12">
                                                    <Table responsive="lg" striped bordered className="hoverable-table">
                                                        <tbody>
                                                            <tr>
                                                                <td><b>Protocol title</b></td>
                                                                <td style={{ whiteSpace: "pre-wrap" }}>{this.state.protocolTitle}</td>
                                                            </tr>
                                                            {(this.state.chemoPremedications !== 'Nil' || this.state.premedications !== 'Nil') && (
                                                            <tr>
                                                                <td><b>Pre-Medications</b></td>
                                                                <td style={{ whiteSpace: "pre-wrap" }}>
                                                                    {this.state.chemoPremedications !== 'Nil' ? this.state.chemoPremedications : this.state.premedications}
                                                                </td>
                                                            </tr>
                                                        )}
                                                        {this.state.chemoSupplements !== 'Nil' && (
                                                            <tr>
                                                                <td><b>Supplements</b></td>
                                                                <td style={{ whiteSpace: "pre-wrap" }}>{this.state.chemoSupplements}</td>
                                                            </tr>
                                                        )}
                                                            <tr>
                                                                <td><b>Antiemetic risk</b></td>
                                                                <td style={{ whiteSpace: "pre-wrap" }}>{this.state.antiemeticRisk}</td>
                                                            </tr>
                                                            <tr>
                                                                <td><b>GCSF medicines</b></td>
                                                                <td style={{ whiteSpace: "pre-wrap" }}>{this.state.gcsfMedicines}</td>
                                                            </tr>
                                                           
                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg="12">
                                                    <Card className="custom-card">
                                                        <Card.Header className="fixed-header"><b>CHEMOTHERAPY DOSE AND METHOD OF ADMINISTRATION</b></Card.Header>
                                                        <Card.Body className="scrollable-card-body">
                                                            <Card.Text style={{ whiteSpace: "pre-wrap" }}>
                                                                 {this.state.treatmentPlan} 
                                                                <br></br>
                                                                 {this.state.treatmentGiven || 'No treatment details available'}
                                                            </Card.Text>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg="12">
                                                    <Table responsive="lg" striped bordered className="hoverable-table">
                                                        <tbody>
                                                            <tr>
                                                                <td><b>Number of days of chemotherapy in each cycle</b></td>
                                                                <td style={{ whiteSpace: "pre-wrap" }}>{this.state.numberOfDaysOfChemotherapyInEachCycle}</td>
                                                            </tr>
                                                            
                                                            <tr>
                                                                <td><b>FN risk</b></td>
                                                                <td style={{ whiteSpace: "pre-wrap" }}>{this.state.fnRisk}</td>
                                                            </tr>
                                                            <tr>
                                                                <td><b>Antithrombotic prophylaxis</b></td>
                                                                <td style={{ whiteSpace: "pre-wrap" }}>{this.state.antithromboticProphylaxis}</td>
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg="12">
                                                    <Card className="custom-card">
                                                        <Card.Header className="fixed-header"><b>TREATMENT PLAN</b></Card.Header>
                                                        <Card.Body className="scrollable-card-body">
                                                        <Card.Text
                            ref={this.contentEditableRef}
                            contentEditable={!this.state.chemoGiven}
                            suppressContentEditableWarning={true}
                            onInput={this.handleContentChange}
                            onBlur={this.handleContentBlur}
                            style={{
                                whiteSpace: "pre-wrap",
                                margin: '15px',
                                padding: '10px',
                                border: '1px solid #ccc',
                                borderRadius: '5px',
                                cursor: this.state.chemoGiven ? 'not-allowed' : 'text',
                                backgroundColor: this.state.chemoGiven ? '#e9ecef' : 'transparent',
                                textAlign: 'left'   // Align text to the left
                            }}
                        >
                            {this.state.specialInstructionToPatients}
                        </Card.Text>
                                                        </Card.Body>
                                                    </Card>
                                                    <Col lg="12" className="text-center" style={{ marginBottom: '20px' }}>
                        <Button
                            variant="secondary"
                            className="btn-primary mr-2 btn-primary mr-2 no-print"
                            disabled={this.state.chemoGiven}
                            onClick={() => this.sendPatientUpdatedInstructions()}
                        >
                            Save
                        </Button>
                    </Col>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg="12">
                                                    <Table responsive="lg" striped bordered className="hoverable-table">
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <b>Email Id's</b><br />
                                                                    <small>If Multiple please provide Comma (,) in between.</small>
                                                                </td>
                                                                <td>
                                                                    <Form.Control
                                                                        type="text"
                                                                        placeholder="Enter Email Id"
                                                                        defaultValue={this.state.chemoTemplateEmailId}
                                                                        name="chemoTemplateEmailId"
                                                                        onChange={this.handleChange}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            </Row>
                                            <Row className="submit">
                                                <Col lg="12" className="text-center">
                                                    <Button
                                                        variant="secondary"
                                                        className="btn-primary mr-2 btn-primary mr-2 no-print"
                                                        onClick={() => this.printForm()}
                                                    >
                                                        Print
                                                    </Button>
                                                    <Button
                                                        variant="secondary"
                                                        className="btn-primary mr-2 btn-primary mr-2 no-print"
                                                        onClick={() => this.sendChemoTemplateMail()}
                                                    >
                                                        Send Mail
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </Container>
                    </div>
                </div>
            </div>
        );
    }
}
